import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Button from '../Button/Button';
import Gravity from '../../constants/Gravity';
import Menu from '../Menu/Menu';
import Snackbar from './Snackbar';

export default class SnackbarExample extends Component {

  state = {
    visible: true,
    selectionCount: 33,
  };

  onChange = e => this.setState(e.target.value);

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Snackbar.defaultProps} propTypes={Snackbar.propTypes} propValues={this.state}>
          <Tip>Try setting the class to <strong>vertical</strong>.</Tip>
        </Properties>
        <div className="snackbar-container">
          <Snackbar {...this.state}>
            <Button iconName="edit">Edit</Button>
            <Button iconName="publish">Publish</Button>
            <Button iconName="unpublish">Unpublish</Button>
            <Menu gravity={Gravity.NORTH} offset={7}>
              <Button iconName="copy">Copy</Button>
              <Button iconName="delete">Delete</Button>
            </Menu>
          </Snackbar>
        </div>
        <SourceCode querySelector=".snackbar-example .core-snackbar"/>
      </Example>
    );
  }

}
